export const RESIDENTS_MOBILE_MESSAGE_MAX_LENGTH = 255;